export default "__VITE_ASSET__CZQU5FF8__"